<template>
<div class="kdx-news-detail">
    <div class="new-center-content">
        <div class="nav-crumb-top">
            <i class="wl-icon-zhuye1" style="color:#05243D;margin-right:8px;"></i>
            <span @click="goHome">首页</span>/
            <span @click="goNews">CHA大讲堂</span>/
            <span style="color:#05243D">详情</span>
        </div>
        <div class="project-content-layer">
            <div class="project-content-title">{{newsInfo.Title}}</div>
            <div class="project-content fr-view">
                <p v-html="newsInfo.Content"></p>
            </div>
        </div>
    </div>
    <!-- 手机端 -->
    <div class="ph-new-center-content">
        <div class="crumbs-text">
            <div style="padding:0 20px;">
                <i style="color:#05243D" class="wl-icon-zhuye1"></i>
                <span @click="goHome" style="cursor: pointer;">首页</span>
                <span>></span>
                <span @click="goNews">CHA大讲堂</span>>
                <span style="color:#05243D">详情</span>
            </div>
        </div>
        <div class="project-content-layers">
            <div class="project-content-title">{{newsInfo.Title}}</div>
            <div class="project-content fr-view">
                <p v-html="newsInfo.Content"></p>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        newsId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            newsInfo: {},
            isShow: 1,
        };
    },
    watch: {
        newsId() {
            this.getNewsInfo();
        }
    },
    created() {
        this.getNewsInfo();
    },
    methods: {
        //获取新闻详情
        getNewsInfo() {
            this.$http
                .post("/api/XOrg/AssociationIndex/getNewsInfo", {
                    Id: this.newsId
                })
                .then(rst => {
                    if (rst.code > 0) {
                        this.newsInfo = rst.newsInfo;
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        //导航栏返回新闻中心
        goNews() {
            this.$router.push({
                name: "xChaClass"
            });
        },
        //返回首页
        goHome() {
            this.$router.push({
                name: "xChaClass"
            });
        },
    },
}
</script>

<style lang="scss">
.kdx-news-detail {
    width: 1200px;
    margin: 0 auto;

    .nav-crumb-top {
        margin-top: 23px;
    }

    .project-content-layer {
        margin-top: 30px;
        background: #F0F0F0;
        border-top: 4px solid #05243D;
        padding: 40px;

        .project-content-title {
            text-align: center;
            color: #05243D;
            font-size: 18px;
            margin: 15px 0 52px 0;
        }

        .project-content {
            color: #646464;
            font-size: 14px;
            line-height: 23px;

            p {
                margin-bottom: 20px;
            }

            img {
                display: block !important;
                margin: 20px auto !important;
                max-width: 90% !important;
            }
        }
    }

    .ph-new-center-content {
        display: none;
    }
}

@media screen and (max-width: 980px) {
    .kdx-news-detail {
        width: 100%;

        .new-center-content {
            display: none;
        }

        .ph-new-center-content {
            display: block;
            background: #fff;

            .crumbs-text {
                background: #F5F7FB;
                height: 40px;
                line-height: 40px;
                color: #666;

                span {
                    margin: 0 3px;
                }
            }

            .project-content-layers {
                border: 1px solid#d3dbe5;
                background: #F0F0F0;
                margin: 10px 15px;
                padding: 10px 10px 30px;

                .project-content-title {
                    color: #05243D;
                    font-size: 16px;
                    text-align: center;
                    margin-bottom: 15px;
                }

                .project-content {
                    color: #646464;
                    font-size: 14px;
                    line-height: 23px;

                    img {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
